import { ImageState } from 'editor/src/store/gallery/types';

import { CrossOrigin } from 'editor/src/component/EditorArea/fabricComponents/FabricImageComponent';

const getImageCrossOriginByState = (imageState: ImageState): CrossOrigin =>
  imageState === ImageState.UPLOADED || imageState === ImageState.LOCAL_PREVIEW ? 'anonymous' : undefined;

export default getImageCrossOriginByState;
